<template>
  <div id="app">
    <!-- 登录页或首页不显示侧边栏 -->
    <router-view v-if="$route.path === '/login' || $route.path === '/'" />
    <!-- 其他内部页面显示侧边栏布局 -->
    <el-container v-else style="height: 100vh">
      <el-aside width="200px" style="display: flex; flex-direction: column; height: 100vh;">
        <div class="logo">华魏WMS</div>
        <!-- 菜单区域，flex:1 撑满剩余空间 -->
        <div style="flex: 1; overflow-y: auto;">
          <side-menu :key="menuTreeKey" :menu-tree="menuTree" />
        </div>
        <!-- 底部内容（工厂切换 + 用户信息）自动贴底 -->
        <div style="margin-top: auto;">
          <div class="factory-switch" v-if="factoryList.length">
            <el-select v-model="currentFactory" size="small" @change="onFactoryChange" placeholder="切换工厂">
              <el-option v-for="f in factoryList" :key="f" :label="f" :value="f"></el-option>
            </el-select>
          </div>
          <div class="user-info">
            <span>{{ username }}</span>
            <el-button type="text" @click="openProfile">个人中心</el-button>
            <el-button type="text" @click="logout">退出</el-button>
          </div>
        </div>
      </el-aside>
      <el-main>
        <router-view />
      </el-main>
    </el-container>

    <!-- 个人中心弹窗 -->
    <Profile ref="profile" />
  </div>
</template>

<script>
import SideMenu from '@/components/SideMenu.vue'
import Profile from '@/views/user/Profile.vue'
import { switchFactory } from '@/api/auth'
import { getMenuTree } from '@/api/menu'
import { addDynamicRoutes, resetRouter } from '@/router'

export default {
  components: { SideMenu, Profile },
  data() {
    return {
      username: localStorage.getItem('username') || '管理员',
      menuTree: [],
      menuTreeKey: 0,   // 用于强制刷新侧边栏
      factoryList: JSON.parse(localStorage.getItem('factories') || '[]'),
      currentFactory: localStorage.getItem('currentFactory') || ''
    }
  },
  async created() {
    const token = localStorage.getItem('token')
    if (token) {
      await this.refreshMenuTree()
    } else {
      this.menuTree = []
      this.menuTreeKey = Date.now()
    }
  },
  watch: {
    '$route'() {
      this.factoryList = JSON.parse(localStorage.getItem('factories') || '[]')
      this.currentFactory = localStorage.getItem('currentFactory') || ''
      if (this.$route.path !== '/login' && this.$route.path !== '/') {
        this.username = localStorage.getItem('username') || '管理员'
      }
    }
  },
  methods: {
    async refreshMenuTree() {
      try {
        // 先清空，触发重新渲染
        this.menuTree = []
        this.menuTreeKey = Date.now()
        const menuTree = await getMenuTree()
        this.menuTree = menuTree
        this.menuTreeKey = Date.now()
        localStorage.setItem('menuTree', JSON.stringify(menuTree))
        resetRouter()
        addDynamicRoutes(menuTree)
      } catch (err) {
        console.error('刷新菜单树失败', err)
      }
    },
    async onFactoryChange(newFactory) {
      try {
        const res = await switchFactory({ factory: newFactory })
        localStorage.setItem('token', res.token)
        localStorage.setItem('currentFactory', newFactory)
        window.location.reload()
      } catch (err) {
        this.$message.error(err.message || '切换失败')
      }
    },
    openProfile() {
      this.$refs.profile.open()
    },
    logout() {
      localStorage.clear()
      this.$router.push('/')
      this.$message.success('已退出登录')
    }
  }
}
</script>

<style scoped>
/* 组件样式（如有需要可覆盖） */
</style>

<style>
/* 全局样式，不添加scoped以影响子组件 */
body {
  margin: 0;
}
.el-aside {
  background-color: #304156;
}
.logo {
  height: 60px;
  line-height: 60px;
  text-align: center;
  color: white;
  font-size: 18px;
  font-weight: bold;
  background-color: #263445;
}
.el-menu {
  border-right: none;
}

/* 工厂切换区域深色主题 */
.factory-switch {
  padding: 16px 20px;
  background-color: #304156;
  border-top: 1px solid #4a5a6e;
}
.factory-switch .el-select {
  width: 100%;
}
.factory-switch .el-input__inner {
  background-color: #263445;
  border-color: #4a5a6e;
  color: #bfcbd9;
}
.factory-switch .el-input__inner:focus {
  border-color: #409EFF;
}
.factory-switch .el-select-dropdown {
  background-color: #263445;
}
.factory-switch .el-select-dropdown__item {
  color: #bfcbd9;
}
.factory-switch .el-select-dropdown__item.hover,
.factory-switch .el-select-dropdown__item:hover {
  background-color: #1e2a3a;
  color: #409EFF;
}

/* 用户信息区域 */
.user-info {
  padding: 16px 20px;
  background-color: #304156;
  border-top: 1px solid #4a5a6e;
  color: #bfcbd9;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.user-info span {
  color: #bfcbd9;
}
.user-info .el-button--text {
  color: #409EFF;
  padding: 0;
  font-size: 14px;
}
</style>